/**
 * The test console's confirmation code (plan-029 WAPP-HIST2; design §40.13.2, §40.19.5, ED-17, DD29-16; FR-CI-18;
 * AC-21). In a test the code a caller would receive by text message is never sent: the runtime publishes it on the
 * test's transcript stream as `confirmation_code_shown { code }`, the api relays it only to the person who started the
 * test, and this card shows it — "Code for this test: 482 913 (not sent by text message)" — so the tester keys or types
 * it as a caller would. It lives in the panel's state only, is replaced by a newer code and goes with the next test;
 * nothing stores or logs it. Drawn inside the existing test console, so it carries no `data-screen-label`.
 */
import { Icon } from "@wetalk/ui";
import type { ReactNode } from "react";

import "./confirmation-code-card.css";

import { groupedConsoleCode } from "../../api/party-confirmation-view.js";
import { portalText, usePortalTranslation } from "../../i18n/portal.js";
import { GLYPH } from "../../shell/glyph.js";

export function ConfirmationCodeCard({ code }: { readonly code: string | null }): ReactNode {
  usePortalTranslation("partyConfirmation");
  if (code === null) return null;
  return (
    <div className="tc-code" role="status" aria-label={portalText("partyConfirmation", "console.code_title")}>
      <Icon glyph={GLYPH.info} size="sm" />
      <span className="tc-code-body">
        <span className="tc-code-line">{portalText("partyConfirmation", "console.code_shown", { code: groupedConsoleCode(code) })}</span>
        <span className="tc-code-note">{portalText("partyConfirmation", "console.code_note")}</span>
      </span>
    </div>
  );
}
